import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { injectIntl } from 'react-intl'
import { Title } from 'components/misc'
import { ParticipantItemWrap } from 'components/sections/assessor'
import { CardLoader } from 'components/loaders'
import { ACTIVITY_SECTIONS, ACTIVITY_STATES, ASSESSOR_WWC_STATE_TYPES } from 'constants/enums'
import config from 'config'
import styles from './participants-list.styl'
import AcceptActivity from '../../../../containers/forms/dashboard/AcceptActivity/AcceptActivity'
import modals from '../../../../constants/layout/modals'
import { modal } from '../../../../helpers/decorators'
import configFile from '../../../../config'
import { apiDashboard } from 'helpers/decorators/api'

@modal.trigger()
@apiDashboard.apiRevise()
@injectIntl
class ParticipantsList extends Component {
  static propTypes = {
    participants: PropTypes.object,
    push: PropTypes.func.isRequired,
    intl: PropTypes.object,
    onOpen: PropTypes.func.isRequired
  }

  state = {
    activityId: null,
    isActivityRequest: false,
    isRpRequest: false,
    isAjRequest: false
  }

  getItemProps = (activity, type) => ({
    activityName:
      type === ACTIVITY_SECTIONS.adventurous_journey.id
        ? get(activity, 'ajEvent.awardLevel.translationText') + ' ' + this.props.intl.formatMessage(
            {
              id: 'moduleTitle.event_journey',
              defaultMessage: '{type} Journey'
            },
            {
              event: get(activity, 'ajEvent.ajEventCategory.translationText')
            }
          )
        : get(activity, 'activityCategory.translatedName'),
    activitySection: type,
    activityState: [
      ACTIVITY_SECTIONS.adventurous_journey.id,
      ACTIVITY_SECTIONS.residential_project.id
    ].includes(type)
      ? get(activity, 'state.value')
      : get(activity, 'activityState.value')
  })

  getItemType = activity => {
    if (
      get(activity, 'activitySection.value') ===
      ACTIVITY_SECTIONS.residential_project.id
    ) {
      return ACTIVITY_SECTIONS.residential_project.id
    } else if (get(activity, 'ajEvent')) {
      return ACTIVITY_SECTIONS.adventurous_journey.id
    } else {
      return get(activity, 'activitySection.value')
    }
  }

  handleOpenAcceptActivityModal = (activity, type) => {
    const isActivityRequest = type === ACTIVITY_SECTIONS.skill.id || type === ACTIVITY_SECTIONS.service.id || type === ACTIVITY_SECTIONS.physical_recreation.id

    const isRpRequest = type === ACTIVITY_SECTIONS.residential_project.id

    const isAjRequest = type === ACTIVITY_SECTIONS.adventurous_journey.id

    const id = isAjRequest ? get(activity, 'ajEvent.id') : get(activity, 'id')

    this.setState({ activityId: id,isActivityRequest, isRpRequest, isAjRequest })
    this.props.onOpen(modals.ACCEPT_ACTIVITY)
  }

  handleClick = (activity, type) => {
    const activityId = get(activity, 'id')

    const wwcExpirationDate = get(activity, 'assessor.assessorWWC.childProtectionExpirationDate')

    const wwcState = get(activity, 'assessor.assessorWWC.state.value')

    const isPending = wwcState && wwcState === ASSESSOR_WWC_STATE_TYPES.pending.id

    const expiredWWC = wwcExpirationDate && (new Date(wwcExpirationDate) < new Date())

    if (expiredWWC && !isPending) {
      this.props.push(`${config.publicPath}/assessor/expired-wwc`)
    } else if(isPending){
      this.props.push(`${configFile.publicPath}/assessor/pending-wwc`)
    }else {
      if (type === ACTIVITY_SECTIONS.adventurous_journey.id) {
        this.props.push(`${config.publicPath}/assessor/adventurous-journey/` + activityId + '/report')
      } else if (type === ACTIVITY_SECTIONS.residential_project.id) {
        this.props.push(`${config.publicPath}/assessor/residential-project/` + activityId + '/report')
      } else {
        this.props.push(`${config.publicPath}/assessor/activity/` + activityId + '/logs')
      }
    }
  }

  determineIcon = (activity, type) => {
    const isAssessmentPositive = get(activity, 'isAssessmentPositive')
    const returnedToParticipant = get(activity, 'returnedToParticipant')
    const { activityState } = this.getItemProps(activity, type)

    return {
      warning:
        [
          ACTIVITY_STATES.setup.id,
          ACTIVITY_STATES.assessment.id,
          ACTIVITY_STATES.in_progress.id
        ].includes(activityState) && returnedToParticipant,
      pending: [
        ACTIVITY_STATES.waiting_for_approval.id,
        ACTIVITY_STATES.award_leader_singoff.id
      ].includes(activityState),
      checked:
        ([
          ACTIVITY_STATES.complete.id,
          ACTIVITY_STATES.ceremony.id,
          ACTIVITY_STATES.office_signoff.id
        ].includes(activityState) &&
          !returnedToParticipant) ||
        (ACTIVITY_STATES.assessment.id === activityState &&
          isAssessmentPositive),
      percent: false,
      assessment:
        ACTIVITY_STATES.assessment.id === activityState && !isAssessmentPositive
    }
  }

  render() {
    const { participants } = this.props

    const allParticipants = get(participants, 'sortedParticipants')

    const sortedParticipants = allParticipants && allParticipants.sort(i1 => {
        return (get(i1, 'activityState.value') === ACTIVITY_STATES.in_progress.id && !get(i1, 'isAcceptedByAssessor')) ||
          (get(i1, 'activityAssessmentRequestActionId') && get(i1, 'activityState.value') === ACTIVITY_STATES.assessment.id) ? -1 : 1
      })

    return (
      <section className={styles.list}>
        {participants.isLoading &&
        sortedParticipants.length === 0 && <CardLoader />}

        {sortedParticipants.length === 0 &&
          !participants.isLoading &&
          participants.isLoaded && (
            <div className="text--center">
              <Title intlKey="moduleTitle.participants_list_is_empty" h2>
                Participants list is empty
              </Title>
            </div>
          )}

        {sortedParticipants.map(activity => {
          const type = this.getItemType(activity)
          const { activityName, activitySection } = this.getItemProps(
            activity,
            type
          )
          const name = `${get(activity, 'participant.firstName')} ${get(
            activity,
            'participant.lastName'
          )}`

          const state = get(activity, 'state.value')

          const isAwardLeaderSignoff = ACTIVITY_STATES.award_leader_singoff.id === state

          const setup = (get(activity, 'isAcceptedByAssessor') === false || get(activity, 'ajEvent.isAcceptedByAssessor') === false)
            && get(activity, 'state.value') === ACTIVITY_STATES.in_progress.id

          const revised = get(activity, 'state.value') === ACTIVITY_STATES.in_progress.id && get(activity, 'activitySignoffActionId')

          const revisedByAssessor = get(activity, 'returnedToParticipant') && !get(activity, 'isAssessmentPositive') && get(activity, 'activityAssessmentActionId')

          return (
            <ParticipantItemWrap
              key={activity.id}
              name={name}
              activityName={activityName}
              activitySection={activitySection}
              activityId={activity.id}
              completedPercentage={get(activity, 'completedPercentage')}
              isAssessmentPositive={get(activity, 'isAssessmentPositive')}
              setup={setup}
              revised={revised && !revisedByAssessor}
              isAwardLeaderSignoff={isAwardLeaderSignoff}
              avatar={get(activity, 'participant.photoUrl')}
              state={get(activity, 'state')}
              sectionIcon={this.determineIcon(activity, type)}
              onClick={() => this.handleClick(activity, type)}
              handleOpenAcceptActivityModal={() => this.handleOpenAcceptActivityModal(activity, type)}
            />
          )
        })}
        <AcceptActivity
          modalId={modals.ACCEPT_ACTIVITY}
          id={this.state.activityId}
          isActivityRequest={this.state.isActivityRequest}
          isRpRequest={this.state.isRpRequest}
          isAjRequest={this.state.isAjRequest}
        />
      </section>
    )
  }
}

export default ParticipantsList

